import { COMP_ICON_MAP, COMP_ICON_WEIGHT_MAP } from "@/utils/getCompIconMap";

const icon = (name, weight) => ({ icon: name, ...(weight ? { iconWeight: weight } : {}) });

/**
 * Returns { icon, iconWeight? } for a given filter config based on its type.
 * Checks target.filterType first for rollup detection, then source.filterType,
 * then falls back to comp for more granular icon resolution.
 */
export const getFilterIcon = (filterConfig) => {
  const targetType = filterConfig?.target?.filterType;
  const sourceType = filterConfig?.source?.filterType;

  // Rollup types — derive icon from source type rather than always showing folder.
  // This gives leaf rollup filters descriptive icons (Tag, ListDashes, etc.)
  // while folder nodes use FolderSimple via PanelItem directly.
  if (targetType === "nestedRollupTagType" || targetType === "rollupValuePathType") {
    // Resolve from source type when available, otherwise fall back to folder
    switch (sourceType) {
      case "tagType":
      case "contentTagType":
        return icon("Tag");
      case "usersType":
      case "authorsType":
        return icon("User");
      case "tplType":
      case "valuePathType": {
        const comp = filterConfig?.comp;
        return icon(COMP_ICON_MAP[comp] || "ListDashes", COMP_ICON_WEIGHT_MAP[comp]);
      }
      default:
        return icon("Tag");
    }
  }

  switch (sourceType) {
    case "tagType":
    case "contentTagType":
      return icon("Tag");

    case "usersType":
    case "authorsType":
      return icon("User");

    case "dateRangeType":
      return icon("CalendarBlank");

    case "numberRangeType":
      return icon("Hash");

    case "tplType":
    case "valuePathType": {
      const comp = filterConfig?.comp;
      return icon(COMP_ICON_MAP[comp] || "ListDashes", COMP_ICON_WEIGHT_MAP[comp]);
    }

    case "staticType":
      return icon("File");

    case "topicClusteringNodeType":
      return icon("ShareNetwork");

    default:
      return icon("FolderSimple");
  }
};
